import { MenuItem, Select, TextareaAutosize, TextField, Button, IconButton, Paper, Alert, Box, Typography, FormControl, InputLabel } from "@mui/material";
import React, { useEffect, useState } from "react";
import graphqlRequest from "../../../requestMethod";
import { message } from "../../Common/SnakeAlert/SnakeAlert";
import eventHelpers from "../../../Helpers/Event";
import CloseIcon from "@mui/icons-material/Close";
import HelpIcon from "@mui/icons-material/Help";
import ErrorIcon from "@mui/icons-material/Error";

let dropdown = [
  { id: 1, value: "Time Mismatch" },
  { id: 2, value: "Different Professional completed the job" },
  { id: 3, value: "Professional Did not showed up" },
  { id: 4, value: "Other" },
];

const JobbShiftPostDetails = ({
  handleCloseDetail,
  selectedData,
  ShiftJobTable,
  fetchShiftLogs,
  setShowQueryModal,
  showQueryModal
}) => {
  let [raiseQuery, setRaiseQuery] = useState({
    reason: "",
    comment: "",
  });

  let [raiseQueryError, setRaiseQueryError] = useState({});
  // const [showQueryModal, setShowQueryModal] = useState(false);

  console.log("raiseQUery", raiseQuery);
  console.log("ShiftJobTable", ShiftJobTable);

  function validate() {
    let error = {};
    if (!raiseQuery.reason) {
      error.reason = "Please select one reason";
    }
    if (!raiseQuery.comment) {
      error.comment = "Please provide reason to remove";
    }
    if (raiseQuery.comment.length < 8) {
      error.comment = "Please provide valid comment";
    }
    return error;
  }

  useEffect(() => {
    setRaiseQueryError(validate());
  }, [raiseQuery]);

  let handleConfirm = () => {
    postRaiseQuery();
    fetchShiftLogs();
    handleCloseDetail(false);
    setShowQueryModal(false);
  };

  console.log("selectedData", selectedData);
  let data = localStorage.getItem("auth");
  let token = JSON.parse(data)?.accessToken;
  let postRaiseQuery = () => {
    const query = `
      mutation {
        mutationWithAuth(token: "${token}") {
          update {
            raiseAQuery(reason: "${raiseQuery.reason}", description: "${raiseQuery.comment}", jobId: "${selectedData.jobId}", jobDate: "1659008700000", department: "${selectedData.specialization}", professionalName: "${selectedData.professionalName}", professionalId: "${selectedData.id}")
            }
          }
        }
      `;

    graphqlRequest(query).then((response) => {
      if (
        response?.data?.mutationWithAuth?.update?.raiseAQuery === "query raised"
      ) {
        message.success("Query has been raised Succesfully");
        setShowQueryModal(false);
      }
    });
  };

  let handleQuery = (data, label) => {
    setRaiseQuery({ ...raiseQuery, [label]: data });
  };

  const fetchUserId = async () => {
    let data = localStorage.getItem("auth");
    let token = JSON.parse(data)?.accessToken;
    try {
      const query = `
    query {
      withAuth(token: "${token}"){
       userDetails{
        id,
        name {
          salutation
          first
          middle
          last
          full
        },
        emails {
          isPrimary
          isVerified
          address
        },
        phoneNumbers{
          number
        }
      }
      }
    }
      `;
      const response = await graphqlRequest(query);
      // console.log("175-->",response)
      return response;
    } catch (error) {
      console.error("Error sending GraphQL request:", error);
    }
  };

  const trackRaisedQueryYes = async () => {
    const user = await fetchUserId();
    // console.log("user---->", user);
    const userId = user.data.withAuth.userDetails.id;
    const userName = user.data.withAuth.userDetails.name.full;
    const userEmail = user.data.withAuth.userDetails.emails[0].address;
    const userPhone = user.data.withAuth.userDetails.phoneNumbers[0].number;

    if (window.Moengage) {
      //set unique id
      window.Moengage.add_unique_user_id(userId);
      //set user attributes
      window.Moengage.add_user_name(userName);
      window.Moengage.add_email(userEmail);
      window.Moengage.add_mobile(userPhone);

      //set event data
      window.Moengage.track_event(
        eventHelpers.SHIFT_LOGS_QUERRY_RAISED
        // {
        // "ID": userId,
        // "name": userName,
        // "Email": userEmail,
        // "date": Date.now(),
        //}
      );
      // window.Moengage.destroy_session();
    }
  };

  const trackRaisedQueryNo = async () => {
    const user = await fetchUserId();
    // console.log("user---->", user);
    const userId = user.data.withAuth.userDetails.id;
    const userName = user.data.withAuth.userDetails.name.full;
    const userEmail = user.data.withAuth.userDetails.emails[0].address;
    const userPhone = user.data.withAuth.userDetails.phoneNumbers[0].number;

    if (window.Moengage) {
      //set unique id
      window.Moengage.add_unique_user_id(userId);
      //set user attributes
      window.Moengage.add_user_name(userName);
      window.Moengage.add_email(userEmail);
      window.Moengage.add_mobile(userPhone);

      //set event data
      window.Moengage.track_event(
        eventHelpers.SHIFT_LOGS_QUERRY_DISCARD
        // {
        // "ID": userId,
        // "name": userName,
        // "Email": userEmail,
        // "date": Date.now(),
        //}
      );
      // window.Moengage.destroy_session();
    }
  };

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        background: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
        p: 2
      }}
      onClick={() => {
        handleCloseDetail(false);
        setShowQueryModal(false);
      }}
    >
      <Paper
        sx={{
          maxWidth: 600,
          width: "100%",
          borderRadius: 3,
          boxShadow: "0 20px 40px rgba(0, 0, 0, 0.15)",
          overflow: "hidden",
          animation: "slideIn 0.3s ease-out"
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <Box
          sx={{
            p: 2,
            background: "linear-gradient(135deg, #2D5FA1 0%, #1e4a8c 100%)",
            color: "white",
            position: "relative"
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <HelpIcon sx={{ fontSize: 28 }} />
            <Typography variant="h6" sx={{ fontWeight: 600, m: 0 }}>
              Raise Query to Admin
            </Typography>
          </Box>
          <IconButton
            onClick={() => {
              handleCloseDetail(false);
              setShowQueryModal(false);
            }}
            sx={{
              position: "absolute",
              top: 12,
              right: 12,
              color: "white",
              "&:hover": { background: "rgba(255, 255, 255, 0.1)" }
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Content */}
        <Box sx={{ p: 3 }}>
          {/* Alert Message */}
          <Alert 
            severity="info" 
            sx={{ 
              mb: 3,
              "& .MuiAlert-message": { fontWeight: 500 }
            }}
          >
            Do you want to raise a query to admin? Please provide details about your issue.
          </Alert>

          {/* Reason Selection */}
          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, color: "#374151" }}>
              Reason for Query <span style={{ color: "#ef4444" }}>*</span>
            </Typography>
            <FormControl fullWidth variant="outlined">
              <InputLabel 
                shrink={!!raiseQuery.reason}
                sx={{
                  "&.MuiInputLabel-shrink": {
                    display: "none"
                  }
                }}
              >
                Reason for query
              </InputLabel>
              <Select
                value={raiseQuery.reason || ""}
                onChange={(e) => handleQuery(e.target.value, "reason")}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2,
                    backgroundColor: "#f9fafb"
                  }
                }}
              >
                <MenuItem value="" disabled>
                  <em>Select a reason...</em>
                </MenuItem>
                {dropdown.map((data) => (
                  <MenuItem key={data.id} value={data.value}>
                    {data.value}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {raiseQueryError.reason && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
                <ErrorIcon sx={{ fontSize: 16, color: "#ef4444" }} />
                <Typography variant="caption" color="error">
                  {raiseQueryError.reason}
                </Typography>
              </Box>
            )}
          </Box>

          {/* Comments */}
          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, color: "#374151" }}>
              Additional Comments <span style={{ color: "#ef4444" }}>*</span>
            </Typography>
            <TextField
              multiline
              rows={4}
              fullWidth
              placeholder="Please provide details about your query..."
              value={raiseQuery.comment || ""}
              onChange={(e) => handleQuery(e.target.value, "comment")}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                  backgroundColor: "#f9fafb"
                }
              }}
            />
            {raiseQueryError.comment && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
                <ErrorIcon sx={{ fontSize: 16, color: "#ef4444" }} />
                <Typography variant="caption" color="error">
                  {raiseQueryError.comment}
                </Typography>
              </Box>
            )}
          </Box>

          {/* Action Buttons */}
          <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end", mt: 4 }}>
            <Button
              variant="outlined"
              onClick={() => {
                handleCloseDetail(false);
                setShowQueryModal(false);
                trackRaisedQueryNo();
              }}
              sx={{
                borderRadius: 2,
                px: 3,
                py: 1,
                textTransform: "none",
                fontWeight: 600,
                borderColor: "#e5e7eb",
                color: "#6b7280",
                "&:hover": {
                  borderColor: "#d1d5db",
                  backgroundColor: "#f9fafb"
                }
              }}
            >
            Cancel
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                handleConfirm();
                trackRaisedQueryYes();
              }}
              disabled={Object.keys(raiseQueryError).length !== 0}
              sx={{
                borderRadius: 2,
                px: 3,
                py: 1,
                textTransform: "none",
                fontWeight: 600,
                backgroundColor: "#2D5FA1",
                "&:hover": {
                  backgroundColor: "#1e4a8c"
                },
                "&:disabled": {
                  backgroundColor: "#93c5fd",
                  color: "#ffffff"
                }
              }}
            >
              Raise Query
            </Button>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default JobbShiftPostDetails;
